import { render } from "./modular.vue?vue&type=template&id=35d7202a&scoped=true"
import script from "./modular.vue?vue&type=script&lang=js"
export * from "./modular.vue?vue&type=script&lang=js"

import "./modular.vue?vue&type=style&index=0&id=35d7202a&lang=scss&scoped=true"

import exportComponent from "D:\\jll-web-xintan\\xinfu-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d7202a"]])

export default __exports__